import styled from '@emotion/styled';
import React from 'react';
import Logo from '@comp/Logo/Logo';
import Close from 'aquilla/icons/actions/Close';

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  flex: 1;
  background-color: transparent;
  z-index: 1000;
  width: 100%;
  height: 100%;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  border-bottom: 1px solid var(--color-divider);
  background-color: var(--color-base-1);
`;

const MenuItem = styled.div`
  padding: 16px;
  background-color: var(--color-base-1);
  border-bottom: 1px solid var(--color-divider);

  a {
    color: var(--color-base-fill);
    text-decoration: none;
    display: block;
  }
`;

const StyledLogo = styled(Logo)`
  @media (max-width: 47.95em) {
    grid-column: 1/2;
  }
`;

const MobileMenu = ({
  isOpen,
  onClose
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  if (!isOpen) return null;

  return (
    <Overlay>
      <Header>
        <StyledLogo />
        <Close onClick={onClose} />
      </Header>
      {[
        { label: 'Schedule', href: '#test-series' },
        { label: 'Test Centres', href: '#test-center' },
        { label: 'Pricing', href: '#test-series' },
        { label: 'FAQs', href: '#faqs' },
        { label: 'Help', href: '#help' }
      ].map(({ label, href }) => (
        <MenuItem key={label} onClick={() => onClose()}>
          <a href={href}>{label}</a>
        </MenuItem>
      ))}
    </Overlay>
  );
};

export default MobileMenu;
